import { createContext, useContext } from 'react';

import type { ModalRegistry } from './modal-registry';

export interface ModalManagerContextValue {
  readonly registry: ModalRegistry;
}

export const ModalManagerContext = createContext<ModalManagerContextValue | null>(null);

export function useModalManagerContext(): ModalManagerContextValue {
  const ctx = useContext(ModalManagerContext);
  if (!ctx) {
    throw new Error(
      '[ModalManager] useModalManagerContext must be used within ModalManagerProvider.',
    );
  }
  return ctx;
}
